export const finishOperationsList = {
  newFinish: "NEW_FINISH",
  updateFinish: "UPDATE_FINISH",
  listFinish: "LIST_FINISH",
  previewFinish: "PREVIEW_FINISH",
};

export const FINISH_STATUS = {
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
};
